import Vue from 'vue'
import App from './App.vue'
import firebase from "firebase"

Vue.config.productionTip = false

  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyCTKQcEPzXV6L2EW7I5uU2shlyf-AAp8KI",
    authDomain: "vue-todo-a1fc8.firebaseapp.com",
    databaseURL: "https://vue-todo-a1fc8.firebaseio.com",
    projectId: "vue-todo-a1fc8",
    storageBucket: "vue-todo-a1fc8.appspot.com",
    messagingSenderId: "591853343203",
    appId: "1:591853343203:web:4daa385354fb6f4c4210d6"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

new Vue({
  render: h => h(App),
}).$mount('#app')
